import { useAuthorization } from 'framework/authorization';
import { FieldProps, useFieldHelper } from 'framework/ui/field';
import { EmployeeLinkFieldWithNameLoading, GET_EMPLOYEES_LIST, useIsCurrentEmployee } from 'domain/shared/employee';

const LeaveWorkerField = ({ source, externalId, value, ...props }: FieldProps) => {
  const { getValue } = useFieldHelper({ source });
  const { isGranted } = useAuthorization();
  const isCurrentEmployee = useIsCurrentEmployee();
  const alias = externalId || value || getValue();

  return (
    <EmployeeLinkFieldWithNameLoading
      source={source}
      externalId={externalId}
      value={value}
      isLink={isGranted(GET_EMPLOYEES_LIST) || isCurrentEmployee(alias)}
      {...props}
    />
  );
};

export default LeaveWorkerField;
